import React from 'react';
import { motion } from 'framer-motion';
export const FadeIn = ({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-50px'
}} transition={{
  duration: 0.6,
  delay,
  ease: 'easeOut'
}} className={className} data-id="element-284">
    {children}
  </motion.div>;
export const CtaButton = ({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <a href="https://pay.hotmart.com/T105430647K" rel="noopener noreferrer" className={`bg-brand-yellow text-brand-charcoal font-bold py-4 px-8 rounded-xl shadow-lg hover:bg-[#d19932] hover:-translate-y-1 transition-all duration-300 text-lg sm:text-xl w-full sm:w-auto inline-flex items-center justify-center gap-2 no-underline cursor-pointer relative z-10 ${className}`} data-id="element-285">
      {children}
    </a>;
};
export const Section = ({
  children,
  bg = 'cream',
  className = '',
  id = ''
}: {
  children: React.ReactNode;
  bg?: 'cream' | 'white' | 'teal';
  className?: string;
  id?: string;
}) => {
  const bgColors = {
    cream: 'bg-brand-cream',
    white: 'bg-white',
    teal: 'bg-brand-teal text-white'
  };
  return <section id={id} className={`py-10 md:py-16 ${bgColors[bg]} ${className}`} data-id="element-286">
      <div className="max-w-4xl mx-auto px-6" data-id="element-287">{children}</div>
    </section>;
};